import { html } from 'lit';
const Mcp =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill="#000" d="M13.518 2.33c.905 0 1.775.354 2.423.985a3.32 3.32 0 0 1 .97 2.853 3.47 3.47 0 0 1 2.908.95l.041.041a3.315 3.315 0 0 1 0 4.754l-7.015 6.879a.22.22 0 0 0-.068.158.22.22 0 0 0 .068.158l1.44 1.415a.66.66 0 0 1 0 .95.695.695 0 0 1-.969 0l-1.441-1.412a1.55 1.55 0 0 1 0-2.22l7.016-6.88a1.99 1.99 0 0 0 0-2.853l-.04-.039a2.086 2.086 0 0 0-2.908-.003l-5.778 5.668-.002.002-.079.079a.696.696 0 0 1-1.12-.217.67.67 0 0 1 .15-.735l5.86-5.747a1.99 1.99 0 0 0-.002-2.85 2.086 2.086 0 0 0-2.908 0l-7.757 7.607a.697.697 0 0 1-.97 0 .665.665 0 0 1 0-.951l7.757-7.607a3.48 3.48 0 0 1 2.424-.985m-.187 2.69a.7.7 0 0 1 .633.415.66.66 0 0 1-.149.733l-5.737 5.626a1.993 1.993 0 0 0 0 2.852 2.087 2.087 0 0 0 2.91 0l5.736-5.625a.696.696 0 0 1 .97 0 .664.664 0 0 1 0 .95l-5.737 5.626a3.477 3.477 0 0 1-4.848 0 3.32 3.32 0 0 1-.743-3.667c.173-.409.426-.778.743-1.087l5.737-5.626a.7.7 0 0 1 .485-.197"/>
  </svg>
`;
export default Mcp;
